import React from 'react';
import { CitySearch } from './CitySearch';
import { Phone } from 'lucide-react';
import { ImageWithFallback } from './ImageWithFallback';

interface SearchHeroProps {
  city?: string;
  state?: string;
  totalResults: number;
}

export function SearchHero({ city, state, totalResults }: SearchHeroProps) {
  return (
    <div className="relative bg-gradient-to-r from-blue-600 to-blue-800 py-12 mb-8">
      <div className="absolute inset-0">
        <ImageWithFallback
          src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80"
          alt="Plumbing background"
          className="w-full h-full object-cover opacity-10"
          sizes="100vw"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-white mb-4">
            {city && state 
              ? `Plumbers in ${city}, ${state}`
              : 'Find Local Plumbers'}
          </h1>
          <p className="text-xl text-gray-100 mb-8">
            {totalResults > 0 
              ? `Found ${totalResults} trusted plumbers in your area`
              : 'Search for licensed and insured plumbers near you'}
          </p>
          <div className="max-w-xl mx-auto">
            <CitySearch />
          </div>
        </div>
      </div>
    </div>
  );
}